// regex should be an instance of a JavaScript regular expression
const regexValidator = (regex: RegExp, value: string) => regex.test(value);

export default regexValidator;
